module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-map card",
    attrs: {
      "id": "fullscreenme"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row full-width"
  }, [_c('div', {
    staticClass: "column p-0"
  }, [_c('GoogleMapContainer', [(_vm.mapCenter.lat !== 0 && _vm.mapCenter.lng !== 0) ? _c('google-map', {
    ref: "map",
    attrs: {
      "searchBar": false,
      "api-key": _vm.mapsAPI,
      "center": _vm.mapCenter,
      "zoom": 13,
      "mapTypeId": 'roadmap',
      "scrollwheel": false,
      "zoomControl": false,
      "mapTypeControl": true,
      "listenForClick": true
    }
  }, [_vm._l((_vm.zones['allowed']), function(allowed) {
    return _c('div', {
      staticClass: "allowed"
    }, _vm._l((allowed.poly), function(poly) {
      return _c('google-map-polygon', {
        attrs: {
          "positions": poly,
          "color": "green",
          "fillColor": "green"
        }
      })
    }), 1)
  }), _vm._l((_vm.zones['forbidden']), function(forbidden) {
    return _c('div', {
      staticClass: "forbidden"
    }, _vm._l((forbidden.poly), function(poly) {
      return _c('google-map-polygon', {
        attrs: {
          "positions": poly,
          "color": "red",
          "fillColor": "red"
        }
      })
    }), 1)
  }), _vm._l((_vm.zones['undesirable']), function(undesirable) {
    return _c('div', {
      staticClass: "undesirable"
    }, _vm._l((undesirable.poly), function(poly) {
      return _c('google-map-polygon', {
        attrs: {
          "positions": poly,
          "color": "yellow",
          "fillColor": "yellow"
        }
      })
    }), 1)
  }), _c('google-map-marker-cluster', {
    ref: "cluster"
  }, _vm._l((_vm.reservations), function(reservation, index) {
    return _c('google-map-marker', {
      key: reservation.id,
      ref: 'marker-' + reservation.id,
      refInFor: true,
      attrs: {
        "icon": _vm.vehicleInRange(reservation.vehicle.in_range),
        "position": {
          lat: reservation.vehicle.position.latitude,
          lng: reservation.vehicle.position.longitude
        },
        "title": reservation.vehicle.model,
        "label": reservation.vehicle.model,
        "labelOrigin": [15, 30]
      }
    }, [_c('reservation', {
      attrs: {
        "item": reservation,
        "type": "sentinel"
      }
    })], 1)
  }), 1)], 2) : _vm._e()], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-3"
  }, [_c('label', [_vm._v("Sentinellable"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.sentinellable),
      expression: "search.sentinellable"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "sentinellable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("No filter")]), _c('option', {
    attrs: {
      "value": "App\\Models\\Client"
    }
  }, [_vm._v("Client")]), _c('option', {
    attrs: {
      "value": "App\\Models\\Reservation"
    }
  }, [_vm._v("Reservation")])])])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Go Full")]), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.fullScreen
    }
  }, [_vm._v("Full screen")])])]), _c('base-list', {
    ref: "baseList",
    attrs: {
      "component": _vm.component,
      "search": _vm.search,
      "data-loader": _vm.loadAlarms
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ac5c131!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/Sentinel.vue
// module id = 2302
// module chunks = 1